var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRestore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0323 20.3931C11.7999 20.3015 11.5892 20.1848 11.5069 19.9258C11.3723 19.5023 11.6624 19.0922 12.1244 19.0771C12.8013 19.055 13.4761 19.0006 14.1206 18.7898C17.0273 17.8392 18.8172 15.8741 19.2702 12.8463C19.8566 8.92359 17.1095 5.31184 13.1904 4.7238C9.70309 4.20041 6.28612 6.33447 5.24426 9.6876C5.22011 9.76453 5.20334 9.84392 5.17633 9.94622C5.28722 9.94622 5.38094 9.94377 5.47465 9.94663C5.76519 9.95605 5.9919 10.0755 6.10443 10.3513C6.21574 10.6239 6.15804 10.8735 5.95057 11.0822C5.54258 11.4931 5.13541 11.9043 4.72005 12.3078C4.43155 12.5877 4.05794 12.5849 3.77108 12.3045C3.35736 11.8998 2.94732 11.491 2.54342 11.0761C2.45626 10.9865 2.40265 10.8641 2.3335 10.7569C2.3335 10.648 2.3335 10.5392 2.3335 10.4303C2.50128 10.0502 2.80123 9.91144 3.20349 9.94336C3.3594 9.95564 3.51695 9.94009 3.67368 9.94704C3.78049 9.95195 3.82468 9.91512 3.85456 9.8075C3.94581 9.48094 4.03666 9.15234 4.15942 8.83684C5.73573 4.79705 9.88437 2.60937 14.1267 3.57717C17.3125 4.30394 19.945 7.05306 20.5072 10.245C20.5682 10.5912 20.614 10.9402 20.6668 11.288C20.6668 11.669 20.6668 12.05 20.6668 12.4314C20.655 12.4764 20.6365 12.521 20.6329 12.5669C20.5302 13.8686 20.1496 15.0864 19.4682 16.1978C18.1252 18.3892 16.19 19.7502 13.6533 20.2319C13.2142 20.3154 12.764 20.3407 12.3188 20.3931C12.2235 20.3931 12.1277 20.3931 12.0323 20.3931Z",
    fill: "#13C296",
    stroke: "#13C296",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39314 14.7086C5.39764 15.0307 5.12879 15.311 4.80469 15.3216C4.47527 15.3327 4.18431 15.054 4.18022 14.7242C4.17613 14.4017 4.44539 14.1214 4.76827 14.1116C5.09973 14.1018 5.38864 14.3776 5.39314 14.7086Z",
    fill: "#13C296",
    stroke: "#13C296",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16173 17.4194C7.16214 17.7521 6.8806 18.0291 6.54709 18.0242C6.2234 18.0193 5.95004 17.7435 5.94922 17.421C5.9484 17.0916 6.23649 16.8076 6.5655 16.8146C6.89083 16.8211 7.16132 17.0957 7.16173 17.4194Z",
    fill: "#13C296",
    stroke: "#13C296",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96082 19.6604C8.63099 19.6604 8.36213 19.3976 8.35558 19.069C8.34904 18.7367 8.62485 18.4609 8.9645 18.4609C9.29515 18.4609 9.56359 18.7228 9.56973 19.0514C9.57546 19.3845 9.29965 19.6604 8.96082 19.6604Z",
    fill: "#13C296",
    stroke: "#13C296",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRestore);
export default __webpack_public_path__ + "static/media/ic_restore.9a6ee09baf8e59c66bccd4be835daa1b.svg";
export { ForwardRef as ReactComponent };